import type { Schema } from '@tix/openapi-sdk'

export type FlowReservation = Schema<'flow_resolution_reservation_response'>

export function subtotalFromCartFees(cartFees: Schema<'cart_fee'>[] | undefined): number | null {
  const fee = cartFees?.find((cartFee) => cartFee.gateway_id === 'stripe')
  if (!fee) return null
  const subtotal = fee?.grand_totals?.total_before_cartmod_price
  if (subtotal === undefined) return null

  const parsed = Number.parseFloat(subtotal)
  return Number.isNaN(parsed) ? null : parsed
}

/** Unset resolver ids serialise as the nil UUID rather than being omitted, so they need excluding. */
const NIL_GUID = '00000000-0000-0000-0000-000000000000'

/**
 * Groups reserved tickets by the resolver that owns their inventory.
 * Absent from the map means not priced yet, not priced at zero.
 */
export function reservedTicketsByResolver(
  reservations: FlowReservation[] | undefined,
  tickets: Schema<'ticket'>[] | undefined,
): Map<string, Schema<'ticket'>[]> {
  const grouped = new Map<string, Schema<'ticket'>[]>()
  if (!reservations?.length || !tickets?.length) return grouped

  const ticketsById = new Map(tickets.map((ticket) => [ticket.id, ticket]))

  for (const reservation of reservations) {
    for (const item of reservation.items ?? []) {
      const resolverId = item.inventory_resolver_id
      if (!resolverId || resolverId === NIL_GUID || !item.ticket_id) continue

      const ticket = ticketsById.get(item.ticket_id)
      if (!ticket) continue

      const existing = grouped.get(resolverId)
      if (existing) existing.push(ticket)
      else grouped.set(resolverId, [ticket])
    }
  }

  return grouped
}

export function ticketValue(ticket: Schema<'ticket'>): number {
  const parsed = Number.parseFloat(ticket.face_value)
  return Number.isNaN(parsed) ? 0 : parsed
}

export function ticketsValue(tickets: Schema<'ticket'>[]): number {
  return tickets.reduce((total, ticket) => total + ticketValue(ticket), 0)
}
